export const dashboardStats = {
  activeAnimals: 128,
  todaySlaughter: 42,
  openCollections: 1245000,
  shareOccupancy: 78,
  pendingTransfers: 17,
  transportPending: 23,
};

export const problems = [
  {
    icon: 'ri-folder-open-line',
    title: 'Dağınık kayıtlar',
    description: 'Excel, defter, WhatsApp ve kağıt fişler arasında veri kaybolur.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Tahsilat takibi zor',
    description: 'Kim ne kadar ödedi, kimin borcu kaldı, hangi havale hangi satışa ait karışır.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Kesim ve teslimat planı karışır',
    description: 'Hisse, hayvan, sıra, kesim günü, taşıma ve teslimat bilgileri birbirine girer.',
  },
  {
    icon: 'ri-user-shared-line',
    title: 'Cari ve aracı takibi net değildir',
    description: 'Özmal müşteriler, şube/aracı üzerinden gelen müşteriler ve hakedişler manuel takip edilir.',
  },
];

export const features = [
  {
    icon: 'ri-smartphone-line',
    title: 'Müşteri Portalı ile Şeffaf Takip',
    description: 'Hissedarlar kendi kurbanını, ödeme geçmişini, kalan bakiyesini, kesim ve teslimat durumunu uygulama indirmeden cep telefonundan takip eder.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Finans ve Anlık Havale Eşleştirme',
    description: 'Nakit, kart ve havale hareketlerini satış ve cari kayıtlarıyla ilişkilendirerek açık tahsilat riskini görünür hale getirin.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Canlı Hayvan Stok Yönetimi',
    description: 'Küpe no, sipariş no, alış kg, satış kg, parti bağlantısı ve durum takibi.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Alım Partileri',
    description: 'Tır bazlı giriş, araç plakası, sürücü, maliyet dağıtımı ve parti kârlılığı.',
  },
  {
    icon: 'ri-knife-line',
    title: 'Dijital Kurban Kesim Sıramatiği ve Operasyon',
    description: 'Kesim günü, sıra numarası, kesim saati, operasyon durumu ve tamamlanan işlemleri tek operasyon havuzunda yönetin.',
  },
  {
    icon: 'ri-pie-chart-line',
    title: 'Kurban Hisse Yönetimi',
    description: 'Hisse sahipleri, grup takibi, ödeme durumu, kalan bakiye ve hayvan bağlantısı yönetimi.',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: 'Havale Takibi ve Finans Çapraz Kontrol',
    description: 'Banka havaleleri, dekont numarası, ödeme eşleştirme ve bekleyen tahsilatları çapraz kontrol edin.',
  },
  {
    icon: 'ri-shopping-cart-2-line',
    title: 'Kurbanlık Satış ve Hisse Takip Programı',
    description: 'Kurban satış, hisse satışı, adaklık, canlı satış, kg bazlı satış ve dış kesim akışlarını aynı kayıt düzeninde yönetin.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Ödeme Takibi',
    description: 'Nakit, kart, havale, dekont eşleştirme, ödeme geçmişi ve kalan bakiye yönetimi.',
  },
  {
    icon: 'ri-contacts-book-2-line',
    title: 'Çiftlik Cari ve Müşteri Takip Sistemi',
    description: 'Müşteri, tedarikçi, kasap, şube, aracı ve özmal cari ayrımını satış ve tahsilat kayıtlarıyla birlikte yönetin.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Taşıma / Teslimat Takibi',
    description: 'Adres, grup no, taşıma durumu ve teslim edilen kayıtların takibi.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Süt ve Et Stok Takibi',
    description: 'Süt, et ve işletmeye özel ürün kalemleri için stok hareketi, satış ve cari bağlantısı.',
  },
  {
    icon: 'ri-egg-line',
    title: 'Kanatlı ve Yumurta İşletmesi',
    description: 'Kanatlı işletmelerde ürün/stok, satış, müşteri ve gelir-gider akışlarının tek panelde takibi.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Aracı / Şube Cari Yapısı',
    description: 'Dışarıdan gelen müşterileri ilgili aracı veya şube cariye bağlayarak raporlama.',
  },
  {
    icon: 'ri-tv-line',
    title: 'TV Ekranları',
    description: 'Kesim operasyon ekranı, havale ekranı ve tesis içi takip ekranları.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Raporlar',
    description: 'Satış, ödeme, cari bakiye, tahsilat riski, kurban doluluk ve gelir/gider raporları.',
  },
  {
    icon: 'ri-shield-user-line',
    title: 'Yetki ve Kullanıcı Yönetimi',
    description: 'Muhasebe, satış, operasyon ve yönetim kullanıcıları için rol bazlı erişim.',
  },
];

export const modules = [
  { icon: 'ri-dashboard-3-line', name: 'Yönetim Paneli' },
  { icon: 'ri-contacts-book-2-line', name: 'Çiftlik Cari ve Müşteri Takip' },
  { icon: 'ri-stack-line', name: 'Canlı Hayvan Stok' },
  { icon: 'ri-truck-line', name: 'Alım Partileri' },
  { icon: 'ri-shopping-cart-2-line', name: 'Kurbanlık Satış ve Hisse Takip' },
  { icon: 'ri-pie-chart-line', name: 'Hisse Ön Satış' },
  { icon: 'ri-knife-line', name: 'Kurban Operasyonu' },
  { icon: 'ri-calendar-check-line', name: 'Dijital Kesim Sıramatiği' },
  { icon: 'ri-map-pin-line', name: 'Taşıma / Teslimat' },
  { icon: 'ri-bank-card-line', name: 'Ödemeler' },
  { icon: 'ri-exchange-dollar-line', name: 'Havaleler' },
  { icon: 'ri-funds-line', name: 'Gelir / Gider' },
  { icon: 'ri-alert-line', name: 'Tahsilat Takip' },
  { icon: 'ri-bar-chart-grouped-line', name: 'Raporlar' },
  { icon: 'ri-smartphone-line', name: 'Müşteri Portalı' },
  { icon: 'ri-tv-line', name: 'TV Ekranları' },
  { icon: 'ri-drop-line', name: 'Süt ve Et Stokları' },
  { icon: 'ri-egg-line', name: 'Kanatlı ve Yumurta' },
  { icon: 'ri-settings-3-line', name: 'Sistem Kontrol' },
];

export const whoIsItFor = [
  {
    icon: 'ri-building-2-line',
    title: 'Kurbanlık ve adaklık işletmeleri',
    description: 'Yoğun dönem satış, hisse, kesim, ödeme ve teslimat takibi.',
  },
  {
    icon: 'ri-home-3-line',
    title: 'Canlı hayvan çiftlikleri',
    description: 'Alım partisi, canlı stok, satış ve maliyet takibi.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Kasap ve et satış işletmeleri',
    description: 'Canlı hayvandan satışa, cari ve ödeme takibine kadar.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Şube veya aracıyla çalışan işletmeler',
    description: 'Özmal ve aracıya bağlı müşterileri ayrı takip etmek isteyen firmalar.',
  },
  {
    icon: 'ri-file-excel-2-line',
    title: "Kağıt/Excel'den çıkmak isteyen işletmeler",
    description: 'Kayıtlarını dijital, güvenli ve raporlanabilir hale getirmek isteyenler.',
  },
];

export const securityCards = [
  {
    icon: 'ri-shield-check-line',
    title: 'Kullanıcı bazlı yetkilendirme',
    description: 'Her kullanıcı yalnızca yetkisi olduğu modüllere ve verilere erişebilir.',
  },
  {
    icon: 'ri-history-line',
    title: 'İşlem geçmişi ve audit log',
    description: 'Tüm işlemler kayıt altına alınır, kimin ne zaman hangi değişikliği yaptığı izlenebilir.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'API + PostgreSQL tabanlı güvenli veri yapısı',
    description: 'Verileriniz güvenli ve yapılandırılmış bir altyapıda saklanır.',
  },
  {
    icon: 'ri-cloud-line',
    title: 'Operasyon verisi tarayıcıda tutulmaz',
    description: 'Tüm kritik veri sunucu tarafında işlenir ve saklanır.',
  },
  {
    icon: 'ri-team-line',
    title: 'Çok kullanıcıyla aynı anda çalışma',
    description: 'Muhasebe, satış ve operasyon ekipleri eş zamanlı çalışabilir.',
  },
  {
    icon: 'ri-building-line',
    title: 'Firma bazlı veri ayrımı',
    description: 'Her işletmenin verisi kendi alanında izole edilir.',
  },
];

export const kurbanOpsCards = [
  {
    icon: 'ri-pie-chart-line',
    title: 'Kurban Hisse Takibi',
    description: 'Hisseli satışlarda kişi, ödeme, kalan bakiye, grup, hayvan ve kesim bilgilerini düzenli takip edin.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Kesim Sırası ve Kesim Planı',
    description: 'Kesim günü, sıra numarası, kesim saati, operasyon durumu ve tamamlanan işlemleri tek ekranda görün.',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: 'Kurban Ödeme ve Havale Takibi',
    description: 'Nakit, kart, havale ve dekont eşleştirme süreçlerini cari bazlı takip edin.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Taşıma ve Teslimat Takibi',
    description: 'Taşıma isteyen müşterileri, adresleri, teslimat durumlarını ve taşıma gruplarını kontrol edin.',
  },
  {
    icon: 'ri-message-3-line',
    title: 'Müşteri Bilgilendirme',
    description: 'Müşteri portalı ile müşterilerin ödeme, kesim ve teslimat durumunu takip etmesini sağlayın.',
  },
  {
    icon: 'ri-tv-line',
    title: 'TV Ekranları',
    description: 'Kesim operasyon ekranı ve havale ekranı ile tesisteki yoğunluğu daha düzenli yönetin.',
  },
];

export const adaklikCards = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Adaklık Satış Kaydı',
    description: 'Adaklık satışlarınızı müşteri, hayvan ve kesim bilgileriyle birlikte kayıt altına alın.',
  },
  {
    icon: 'ri-calendar-line',
    title: 'Kesim Tarihi ve Kesim Saati',
    description: 'Her adaklık kaydı için kesim tarihi ve saatini planlayın, operasyon akışını düzenleyin.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Ödeme ve Kalan Bakiye',
    description: 'Adaklık satışlarında ödeme durumunu takip edin, kalan bakiyeleri cari kart üzerinden görün.',
  },
  {
    icon: 'ri-contacts-book-line',
    title: 'Müşteri Cari Kartı',
    description: 'Her müşterinin adaklık geçmişini, ödemelerini ve kesim bilgilerini tek kartta toplayın.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Taşıma / Teslimat Bilgisi',
    description: 'Adaklık kesim sonrası taşıma ve teslimat bilgilerini kaydedin, teslimat durumunu takip edin.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Müşteri Portalı',
    description: 'Müşterinin kendi ödeme, kesim ve teslimat bilgisini takip edebilmesi için portal altyapısı.',
  },
];

export const comparisonRows = [
  {
    label: 'Hisse takibi',
    manual: 'Defter veya Excel sayfasında dağınık',
    ciftlikweb: 'Hisse sahibi, grup, ödeme ve hayvan bağlantısıyla düzenli',
  },
  {
    label: 'Ödeme takibi',
    manual: 'Hangi ödeme hangi satışa ait karışır',
    ciftlikweb: 'Her ödeme cari karta ve satışa otomatik bağlanır',
  },
  {
    label: 'Havale eşleştirme',
    manual: 'Banka ekstresi ve WhatsApp dekontları arasında kaybolur',
    ciftlikweb: 'Dekont numarası ve tutar ile sisteme kaydedilir, otomatik eşleşir',
  },
  {
    label: 'Kesim sırası',
    manual: 'Kağıt liste veya anlık sözlü planlama',
    ciftlikweb: 'Kesim günü, sıra no, saat ve durum dijital olarak takip edilir',
  },
  {
    label: 'Taşıma bilgileri',
    manual: 'Adresler WhatsApp\'ta kaybolur',
    ciftlikweb: 'Adres, grup no ve teslimat durumu sistemde kayıtlıdır',
  },
  {
    label: 'Cari bakiyeler',
    manual: 'Kimin ne kadar borcu kaldığı bilinmez',
    ciftlikweb: 'Her müşterinin anlık cari bakiyesi görülebilir',
  },
  {
    label: 'Müşteri bilgilendirme',
    manual: 'Tek tek telefonla arama',
    ciftlikweb: 'Müşteri portalı üzerinden kayıtlı süreçleri görünür kılma',
  },
  {
    label: 'Raporlama',
    manual: 'Saatler süren Excel çalışması',
    ciftlikweb: 'Tek tıkla satış, ödeme, cari ve operasyon raporları',
  },
  {
    label: 'Çok kullanıcılı çalışma',
    manual: 'Aynı dosyayı birden fazla kişi açamaz',
    ciftlikweb: 'Satış, muhasebe ve operasyon ekipleri eş zamanlı çalışabilir',
  },
  {
    label: 'Geçmiş kayıt arama',
    manual: 'Eski defterler ve dosyalar arasında arama',
    ciftlikweb: 'Tüm geçmiş kayıtlar içinde saniyeler içinde arama',
  },
];

export const faqItems = [
  {
    question: 'CiftlikWeb paketlere ayrılıyor mu?',
    answer: 'Hayır. CiftlikWeb Pro tek üründür. Canlı hayvan, süt/et stokları, kanatlı işletme, cari, ödeme, havale, portal, kurban, kesim ve taşıma akışı birlikte çalışır; yarım sistem veya eksik modül olarak satılmaz.',
  },
  {
    question: 'CiftlikWeb Pro fiyatı nedir?',
    answer: 'Kurulum ve aktivasyon 70.000 TL + KDV, aylık kullanım 7.000 TL + KDV olarak planlanır. Sözleşme 12 ay taahhütlüdür.',
  },
  {
    question: 'İlk ay cayma hakkı var mı?',
    answer: 'Evet. İlk 30 gün içinde cayma hakkı vardır. Cayma halinde kalan taahhüt iptal edilir; kurulum ve aktivasyon bedeli iade edilmez.',
  },
  {
    question: 'Kendi domainimizi kullanabilir miyiz?',
    answer: 'Evet. İsterseniz firmaadi.ciftlikweb.com şeklinde CiftlikWeb alt domaini, panel.firma.com gibi kendi yönettiğiniz domain veya işletmeniz için bizim aldığımız/yönettiğimiz özel domain kullanılabilir.',
  },
  {
    question: 'CiftlikWeb sadece Kurban Bayramı için mi kullanılır?',
    answer: 'Hayır. CiftlikWeb yıl boyunca canlı hayvan stok, satış, ödeme, cari ve rapor takibi için kullanılabilir. Kurban Bayramı operasyonları için ayrıca güçlü kurban hisse, kesim ve taşıma modülleri sunar.',
  },
  {
    question: 'Kurban hisse takip programı olarak kullanılabilir mi?',
    answer: 'Evet. Hisse sahipleri, grup bilgileri, ödeme durumu, kalan bakiye, hayvan bağlantısı ve kesim bilgileri CiftlikWeb üzerinden takip edilebilir.',
  },
  {
    question: 'Kurban kesim sırası takip edilebilir mi?',
    answer: 'Evet. Kesim günü, kesim saati, sıra numarası, operasyon durumu ve tamamlanan işlemler kayıt altına alınabilir.',
  },
  {
    question: 'Adaklık satış ve kesim takibi yapılabilir mi?',
    answer: 'Evet. Adaklık satış, ödeme, kesim tarihi, teslimat ve müşteri cari bilgileri aynı sistemde yönetilebilir.',
  },
  {
    question: 'Havale ve banka ödemeleri takip edilebilir mi?',
    answer: 'Evet. Havale kayıtları, dekont numarası, ödeme eşleştirme ve bekleyen havaleler sistem üzerinden takip edilebilir.',
  },
  {
    question: 'Müşteriler kendi bilgilerini görebilir mi?',
    answer: 'Evet. Cari Portal ile müşteriler kendi siparişlerini, ödeme geçmişini, kalan bakiyesini, kesim ve taşıma durumunu görebilir.',
  },
  {
    question: 'Taşıma ve teslimat takibi var mı?',
    answer: 'Evet. Taşıma isteyen müşteriler, adresler, grup numaraları, taşıma durumu ve teslimat bilgileri takip edilebilir.',
  },
  {
    question: 'Kurbanlık satış takip programı olarak kullanılabilir mi?',
    answer: 'Evet. Kurbanlık satış, hisse satışı, canlı satış, ödeme takibi, kesim planı ve teslimat süreçleri CiftlikWeb üzerinden yönetilebilir.',
  },
  {
    question: 'Canlı hayvan stok takibi yapılabilir mi?',
    answer: 'Evet. Küpe no, sipariş no, alış kg, satış kg, alım partisi, satış durumu ve operasyon durumu takip edilebilir.',
  },
  {
    question: 'Birden fazla kullanıcı aynı anda çalışabilir mi?',
    answer: 'Evet. Satış, muhasebe, operasyon ve yönetim ekipleri farklı yetkilerle aynı sistem üzerinde çalışabilir.',
  },
  {
    question: 'Özmal müşteri ve aracı/şube müşterileri ayrılabilir mi?',
    answer: 'Evet. CiftlikWeb\'de direkt özmal cariler ve aracı/şube üzerinden gelen cariler ayrı takip edilebilir.',
  },
  {
    question: 'Raporlama var mı?',
    answer: 'Evet. Satış, ödeme, cari bakiye, tahsilat riski, kurban doluluk, gelir-gider ve operasyon raporları alınabilir.',
  },
  {
    question: 'TV ekranı desteği var mı?',
    answer: 'Evet. Kesim operasyon ekranı ve havale ekranı gibi tesis içinde kullanılabilecek TV ekranları planlanabilir.',
  },
  {
    question: 'Her işletmenin kendi domaini olması gerekir mi?',
    answer: 'Hayır. Domaini olmayan işletmeler için firmaadi.ciftlikweb.com şeklinde subdomain kullanılabilir. Dilerseniz müşteri adına alınmış ve bizim yönettiğimiz evrenciftligi.com benzeri domainler de sisteme bağlanabilir.',
  },
  {
    question: 'CiftlikWeb küçük işletmeler için uygun mu?',
    answer: 'Evet. Küçük işletmeler temel satış, ödeme ve cari takibi için kullanabilir. Daha büyük işletmeler kurban, kesim, taşıma, portal ve rapor modüllerini aktif kullanabilir.',
  },
  {
    question: "Excel'den geçiş yapılabilir mi?",
    answer: 'Uygun formatta hazırlanmış Excel verileri için aktarım planı yapılabilir.',
  },
  {
    question: 'Havale ekranı ne işe yarar?',
    answer: 'Havale ekranı, gelen havalelerin ve ödeme durumlarının operasyon ekibi tarafından daha kolay takip edilmesini sağlar.',
  },
  {
    question: 'Kesim günü yoğunluğunu azaltmaya yardımcı olur mu?',
    answer: 'Evet. Kesim sırası, ödeme durumu, taşıma bilgisi ve müşteri bilgilendirme tek sistemde toplandığı için operasyon daha düzenli ilerler.',
  },
  {
    question: 'Demo alabilir miyiz?',
    answer: 'Evet. Demo talep ederek CiftlikWeb\'in kurban, adaklık, satış, cari ve ödeme modüllerini canlı olarak inceleyebilirsiniz.',
  },
];

export const navLinks = [
  { label: 'Ana Sayfa', href: '#hero' },
  { label: 'Özellikler', href: '#ozellikler' },
  { label: 'Kurban Modülü', href: '#kurban-operasyon' },
  { label: 'Modüller', href: '#moduller' },
  { label: 'Kimler İçin?', href: '#kimler-icin' },
  { label: 'Fiyat / Demo', href: '#demo' },
  { label: 'İletişim', href: '#iletisim' },
];
